module.exports = __webpack_public_path__ + "img/img_06.c63ea5a0.webp";